import { render, staticRenderFns } from "./aluno-sexo.vue?vue&type=template&id=65a3cef4&"
import script from "./aluno-sexo.vue?vue&type=script&lang=js&"
export * from "./aluno-sexo.vue?vue&type=script&lang=js&"
import style0 from "./aluno-sexo.vue?vue&type=style&index=0&id=65a3cef4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports